import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  // From previously-saved value
  advancedMode:
    typeof window != "undefined"
      ? window.localStorage.getItem("mode.advanced") == "true"
      : false,
}

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setAdvancedMode: (state, action) => {
      state.advancedMode = action.payload
      if (typeof window != "undefined") {
        window.localStorage.setItem(
          "mode.advanced",
          action.payload ? "true" : "false"
        )
      }
    },
  },
})

// Selector for all the pipeline names
export const selectAdvancedMode = (state) => state.settings.advancedMode

export const { setAdvancedMode } = settingsSlice.actions

export default settingsSlice.reducer
